// extracted by mini-css-extract-plugin
export default {"bell":"Bell_bell__6n-hp","bell_messages":"Bell_bell_messages__dlPZh"};